import axios, { AxiosResponse } from "axios";

enum ETipo {
  _,
  texto,
  texto_multilinha,
  selecao,
  data,
  booleano,
  intervalo_data,
  selecao_multipla
}

export interface ICampoPrograma {
  id?: number;

  nome: string;

  tipocampo_id: number;

  obrigatorio: boolean;

  ordem: number;

  configuracao: Record<string, any>;
}

export interface IOpcaoCampoPrograma {
  id?: number;
  nome: string;
}

export interface ICampoProgramaSync {
  id?: number;

  nome: string;

  tipocampo_id: number;

  obrigatorio: boolean;

  ordem: number;

  configuracao: Record<string, any>;

  opcoes?: IOpcaoCampoPrograma[];
}

export async function syncCamposPrograma(
  campos: ICampoProgramaSync[],
): Promise<AxiosResponse<void>> {
  return axios.post(
    "/campoprograma/sync",
    campos,
  );
}

export async function getCamposPrograma(): Promise<
  AxiosResponse<ICampoPrograma[]>
> {
  return axios.get("/campoprograma");
}

export async function getCampoPrograma(
  id: number | string,
): Promise<AxiosResponse<ICampoPrograma>> {
  return axios.get(`/campoprograma/${id}`);
}

export async function createCampoPrograma(
  nome: string,
  tipo_id: number,
): Promise<AxiosResponse<void>> {
  return axios.post("/campoprograma", {
    nome,
    tipo_id,
  });
}

export async function updateCampoPrograma(
  id: number | string,
  nome: string,
  tipo_id: number,
): Promise<AxiosResponse<void>> {
  return axios.put(`/campoprograma/${id}`, {
    nome,
    tipo_id,
  });
}

export async function deleteCampoPrograma(
  id: number | string,
): Promise<AxiosResponse<void>> {
  return axios.delete(`/campoprograma/${id}`);
}

export async function getOpcoesCampoPrograma(
  campoId: number | string,
): Promise<AxiosResponse<IOpcaoCampoPrograma[]>> {
  return axios.get(`/campoprograma/${campoId}/opcoes`);
}

export async function createOpcaoCampoPrograma(
  campoId: number | string,
  nome: string,
): Promise<AxiosResponse<void>> {
  return axios.post(`/campoprograma/${campoId}/opcoes`, {
    nome,
  });
}

export async function updateOpcaoCampoPrograma(
  campoId: number | string,
  opcaoId: number | string,
  nome: string,
): Promise<AxiosResponse<void>> {
  return axios.put(
    `/campoprograma/${campoId}/opcoes/${opcaoId}`,
    {
      nome,
    },
  );
}

export async function deleteOpcaoCampoPrograma(
  campoId: number | string,
  opcaoId: number | string,
): Promise<AxiosResponse<void>> {
  return axios.delete(
    `/campoprograma/${campoId}/opcoes/${opcaoId}`,
  );
}